<template>
  <div class="date-filter text-center">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          class="date-filter__menu-icon date-filter__menu-icon--down"
          light
        >
          mdi-menu-down
        </v-icon>
        <v-icon
          v-bind="attrs"
          class="date-filter__menu-icon date-filter__menu-icon--up"
          light
        >
          mdi-menu-up
        </v-icon>
        <v-text-field
          v-model="dateRangeText"
          :label="label"
          clearable
          prepend-inner-icon="mdi-calendar-month"
          append-inner-icon="mdi-calendar-month"
          outlined
          dense
          readonly
          light
          v-bind="attrs"
          @click:clear="clearDates()"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="dates"
        range
      />
    </v-menu>
  </div>
</template>

<script>
import formModal from '@/mixins/form-modal';
import { mapState } from 'vuex';

export default {
  name: 'DateFilter',
  mixins: [
    formModal,
  ],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapState('misc', [
      'formModal',
    ]),
    dateRangeText: {
      get() {
        const newDates = this.dates.map(date => this.formatDate(date));
        return newDates.join(' - ');
      },
      set(newValue) {
        return newValue;
      }
    },
    dates: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    },
  },
  methods: {
    clearDates() {
      this.dates = [];
    }
  },
};
</script>

<style scoped lang="scss">
  .date-filter {
    position: relative;
    display: flex;
    margin-top: 2px;

    &__close-icon {
      position: absolute;
      right: 34px;
      top: 8px;
      pointer-events: none;
      z-index: inherit;
    }

    &__menu-icon {
      position: absolute;
      right: 10px;
      top: 6px;
      pointer-events: none;
      z-index: inherit;
      display: none;

      &--up[aria-expanded="true"] {
        display: block;
      }

      &--down[aria-expanded="false"] {
        display: block;
      }
    }
  }

  ::v-deep {
    .v-text-field {
      width: 287px !important;
    }

    button {
      margin-right: 40px;
    }
}
</style>

